import { createHandlerChainRunner, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { getBrandFaqs, GetBrandFaqsApiParameter, FaqModel, FaqCollectionModel } from "@tCentro/Services/CENBrandFAQService";

type Parameter =
    GetBrandFaqsApiParameter &
    HasOnSuccess<FaqCollectionModel>;
type Props = {
    apiParameter: GetBrandFaqsApiParameter;
    apiResult: FaqCollectionModel;
};

type HandlerType = Handler<Parameter, Props>;

export const DispatchBeginLoadBrandFaqs: HandlerType = props => {
    props.dispatch({
        type: "Custom/FaqData/BeginLoad",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getBrandFaqs(props.apiParameter);
    } catch (error) {
        if (error?.status === 404) {
            props.dispatch({
                type: "Custom/Faq/CompletedLoad",
                result: [],
            });
            return false;
        }
        throw error;
    }
};


export const DispatchCompleteLoadBrandFaqs: HandlerType = props => {
    props.dispatch({
        type: "Custom/Faq/CompletedLoad",
        result: props.apiResult,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [
    DispatchBeginLoadBrandFaqs,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteLoadBrandFaqs,
    ExecuteOnSuccessCallback,
];

const loadBrandFaqs = createHandlerChainRunner(chain, "LoadBrandFaqs");
export default loadBrandFaqs;
 